import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { IoChevronUp } from "react-icons/io5";

const PublicLayout = () => {
  const [isScrollVisible, setIsScrollVisible] = useState(false);

  // Check if current page is a report detail page (e.g., /reports/some-slug)
  // We match /reports/:slug but NOT the main /reports page
  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsScrollVisible(true);
    } else {
      setIsScrollVisible(false);
    }
  };

  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      <Header />
      <Outlet />
      <Footer />

      <div className="fixed-actions-container">
        <button
          type="button"
          className={`scroll-to-top-btn ${isScrollVisible ? "show" : ""}`}
          onClick={scrollToTop}
          title="Scroll to Top"
          aria-label="Scroll to top"
        >
          <IoChevronUp size={20} />
        </button>

        <div className="demo-button-sticky">
          <a
            href="https://calendly.com/rw-researchwire/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="demo-button-video"
          >
            Book a Demo
          </a>
        </div>
      </div>
    </>
  );
};

export default PublicLayout;
